import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import utils from '../../../utils/utils'
import useTitle from '../../../hooks/useTitle'
import Dashboards from './Dashboards'
import Explore from './Explore'
import Export from './Export'
import Integrations from './Integrations'

export default function Results () {
  const { user, trial } = useStore()
  useTitle('Results', trial)
  return (
    <Stack gap={5}>
      <SimpleTabs
        tabs={[
          { title: 'Dashboards', content: <Dashboards /> },
          { title: 'Explore', content: <Explore /> },
          utils.canExportData(user, trial) && { title: 'Export', content: <Export /> },
          // Integrations set up an ongoing external data sync — an admin-gated
          // action (can_manage_trial), so only surface the tab to admins.
          utils.canManageTrial(user, trial) && { title: 'Integrations', content: <Integrations /> }
        ]}
      />
    </Stack>
  )
}
